module.exports = __webpack_public_path__ + "img/article_status_go.01936408.png";